(function () {
  function init(marca, comb, modelo) {
    function dispatchNativeEvents(el) {
      try {
        el.dispatchEvent(new Event('input', { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {
        var evt1 = document.createEvent('Event');
        evt1.initEvent('input', true, true);
        el.dispatchEvent(evt1);

        var evt2 = document.createEvent('Event');
        evt2.initEvent('change', true, true);
        el.dispatchEvent(evt2);
      }
    }

    function setHidden(name, value) {
    var elements = document.querySelectorAll('[name="' + name + '"]');
    if (!elements.length) {      
      return;
    }

    var finalValue = (value !== null && value !== undefined) ? String(value) : '';

    elements.forEach(function (el) {
      el.value = finalValue;
      el.setAttribute('value', finalValue);

      try {
        el.dispatchEvent(new Event('input',  { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {
        var evt1 = document.createEvent('Event');
        evt1.initEvent('input', true, true);
        el.dispatchEvent(evt1);

        var evt2 = document.createEvent('Event');
        evt2.initEvent('change', true, true);
        el.dispatchEvent(evt2);
      }
    });
  }

    function clearVehicleHiddenFields() {
      [
      'hidden_impvehic',
      'hidden_marca_coche',
      'hidden_potencia_fiscal',
      'hidden_cilindrada',
      'hidden_modelo_coche',
      'hidden_cilindros',
      'hidden_potencia_cv',
      'hidden_potencia_kw',
      'hidden_combustible',
    ].forEach(function (fieldName) {
      setHidden(fieldName, '');
    });
  }

    function setOptions(select, options, placeholder) {
      select.innerHTML = '';

      var ph = document.createElement('option');
      ph.value = '';
      ph.textContent = placeholder || 'Selecciona...';
      select.appendChild(ph);

      (options || []).forEach(function (opt) {
        var o = document.createElement('option');
        o.value = opt.value;
        o.textContent = opt.label;
        select.appendChild(o);
      });

      dispatchNativeEvents(select);
    }

    function fetchJSON(url) {
      return fetch(url, { credentials: 'same-origin' }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      });
    }

    function loadMarcas() {
      return fetchJSON('/wp-json/catalogos/v1/coches/marcas').then(function (data) {
        setOptions(marca, data.options || [], 'Selecciona marca');
        setOptions(comb, [], 'Selecciona combustible');
        setOptions(modelo, [], 'Selecciona modelo');
        clearVehicleHiddenFields();
      });
    }

    function loadCombustibles(marcaVal) {
      return fetchJSON('/wp-json/catalogos/v1/coches/combustibles?marca=' + encodeURIComponent(marcaVal)).then(function (data) {
        setOptions(comb, data.options || [], 'Selecciona combustible');
        setOptions(modelo, [], 'Selecciona modelo');
        clearVehicleHiddenFields();
      });
    }

    function loadModelos(marcaVal, combVal) {
      var url = '/wp-json/catalogos/v1/coches/modelos?marca=' + encodeURIComponent(marcaVal) + '&comb=' + encodeURIComponent(combVal);

      return fetchJSON(url).then(function (data) {
        setOptions(modelo, data.options || [], 'Selecciona modelo');
        clearVehicleHiddenFields();
      });
    }

    var combustibleMap = {
      'D': 'Diésel',
      'G': 'Gasolina',
      'E': 'Eléctrico',
      'H': 'Híbrido',
      'P': 'Híbrido enchufable',
      'S': 'Gas',
      'M': 'Multicombustible',
    };

    function loadDetalle(seq) {
      return fetchJSON('/wp-json/catalogos/v1/coches/by-seq?seq=' + encodeURIComponent(seq)).then(function (data) {
        setHidden('hidden_potencia_fiscal', data && data.cvfvehic);
        setHidden('hidden_cilindrada', data && data.cilvehic);
        setHidden('hidden_impvehic', data && data.impvehic);

        setHidden('hidden_marca_coche', data && data.marvehic);
        setHidden('hidden_modelo_coche', data && data.modvehic);
        setHidden('hidden_cilindros', data && data.ncivehic);
        setHidden('hidden_potencia_cv', data && data.pcvvehic);
        setHidden('hidden_potencia_kw', data && data.pkwvehic);

        var comCodigo = data && data.comvehic ? String(data.comvehic).trim().toUpperCase() : '';
        setHidden('hidden_combustible', combustibleMap[comCodigo] || comCodigo);

        window.dispatchEvent(new CustomEvent('itp:vehiculo-updated'));
      });
    }

    marca.addEventListener('change', function () {
      var v = marca.value;
      clearVehicleHiddenFields();

      if (!v) {
        setOptions(comb, [], 'Selecciona combustible');
        setOptions(modelo, [], 'Selecciona modelo');
        return;
      }

      loadCombustibles(v).catch(function (e) {
        console.error(e);
      });
    });

    comb.addEventListener('change', function () {
      var mv = marca.value;
      var cv = comb.value;
      clearVehicleHiddenFields();

      if (!mv || !cv) {
        setOptions(modelo, [], 'Selecciona modelo');
        return;
      }

      loadModelos(mv, cv).catch(function (e) {
        console.error(e);
      });
    });

    modelo.addEventListener('change', function () {
      var seq = modelo.value;

      if (!seq) {
        clearVehicleHiddenFields();
        return;
      }

      loadDetalle(seq).catch(function (e) {
        console.error(e);
      });
    });

    loadMarcas().catch(function (e) {
      console.error(e);
    });
  }

  function getElements() {
    return {
      marca:  document.querySelector('select[name="marca_coche"]'),
      comb:   document.querySelector('select[name="tcombustible_coche"]'),
      modelo: document.querySelector('select[name="modelo_coche"]'),
    };
  }

  function tryInit() {
    var els = getElements();
    if (els.marca && els.comb && els.modelo) {
      init(els.marca, els.comb, els.modelo);
      return true;
    }
    return false;
  }

  // Intentar inmediatamente; si los selects aún no existen (JFB los renderiza
  // de forma asíncrona), un MutationObserver espera a que aparezcan en el DOM.
  if (!tryInit()) {
    var observer = new MutationObserver(function () {
      if (tryInit()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

// ─── Reset de tipo de vehículo y sincronización de campos "no listado" ───────
document.addEventListener('DOMContentLoaded', function () {

  function dispatchEvents(el) {
    try {
      el.dispatchEvent(new Event('input', { bubbles: true }));
      el.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) {
      // eslint-disable-next-line no-unused-vars
      // Ignoramos el error intencionalmente
    }
  }

  function clearTextField(name) {
    document.querySelectorAll('[name="' + name + '"]').forEach(function (el) {
      el.value = '';
      dispatchEvents(el);
    });
  }

  function clearSelectField(name) {
    var el = document.querySelector('select[name="' + name + '"]');
    if (el) { el.selectedIndex = 0; dispatchEvents(el); }
  }

  var HIDDEN_VEHICULO = [
    'hidden_marca_coche', 'hidden_modelo_coche', 'hidden_combustible',
    'hidden_cilindrada', 'hidden_cilindros', 'hidden_potencia_kw',
    'hidden_potencia_cv', 'hidden_potencia_fiscal', 'hidden_impvehic',
  ];

  function clearVehiculoHidden() {
    HIDDEN_VEHICULO.forEach(clearTextField);
    window.dispatchEvent(new CustomEvent('itp:vehiculo-updated'));
  }

  // ── Reset completo al cambiar el tipo de vehículo ──────────────────────────
  function resetAlCambiarVehiculo() {
    var vehiculoInput = document.querySelector('[name="elegir_vehiculo"]:checked');
    var vehiculoValue = vehiculoInput ? vehiculoInput.value : '';
    if (!vehiculoValue) return;

    if (vehiculoValue === 'veh_coche') {
      clearTextField('marca_moto');
      clearTextField('fecha_primera_matriculacion');
      clearTextField('modelo_moto');
      clearSelectField('cilindrada_moto');
      clearSelectField('ccaa_comprador');
    } else if (vehiculoValue === 'veh_moto') {
      clearSelectField('marca_coche');
      clearTextField('fecha_primera_matriculacion');
      clearSelectField('tcombustible_coche');
      clearSelectField('modelo_coche');
      clearSelectField('ccaa_comprador');
    }

    clearVehiculoHidden();
    clearTextField('fecha_primera_matriculacion');
    clearTextField('hidden_antiguedad');
    clearSelectField('ccaa_comprador');

    var cbNoListado = document.querySelector('[name="checkbox_veh_no_listado"]');
    if (cbNoListado) {
      cbNoListado.checked = false;
      dispatchEvents(cbNoListado);
    }
    clearTextField('modelo_vehiculo_no_listado');
    clearTextField('fecha_primera_matriculacion');
    clearTextField('cilindrada_vehiculo_no_listado');
    clearTextField('potencia_fiscal_vehiculo_no_listado');
    clearSelectField('ccaa_comprador');
  }

  function watchChoiceField() {
    var choiceItems = document.querySelectorAll(
      '.jet-form-builder-choice--item'
    );

    choiceItems.forEach(function (li) {
      var radio = li.querySelector('[name="elegir_vehiculo"]');
      if (!radio) return;

      new MutationObserver(function (mutations) {
        mutations.forEach(function (mut) {
          if (
            mut.attributeName === 'class' &&
            li.classList.contains('is-checked') &&
            radio.checked
          ) {
            setTimeout(resetAlCambiarVehiculo, 0);
          }
        });
      }).observe(li, { attributes: true });
    });
  }

  // Intentar inmediatamente; si JFB aún no renderizó los LI, esperar con observer
  function tryWatchChoiceField() {
    var items = document.querySelectorAll(
      '.jet-form-builder-choice--item'
    );
    var hasVehiculo = Array.from(items).some(function (li) {
      return li.querySelector('[name="elegir_vehiculo"]');
    });
    if (hasVehiculo) {
      watchChoiceField();
      return true;
    }
    return false;
  }

  if (!tryWatchChoiceField()) {
    var obs = new MutationObserver(function () {
      if (tryWatchChoiceField()) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  } 

  // ── Sincronización de campos manuales cuando "mi modelo no aparece" ────────
  function syncCamposNoListado() {
    var cb = document.querySelector('[name="checkbox_veh_no_listado"]:checked');
    if (!cb || !cb.checked) {
      // Al desmarcar: resetear los campos del vehículo para que el usuario
      // vuelva a seleccionar desde el catálogo
      var vehInput = document.querySelector('[name="elegir_vehiculo"]');
      var vehVal = vehInput ? vehInput.value : '';
      if (vehVal === 'veh_coche') {
        clearSelectField('marca_coche');
        clearSelectField('tcombustible_coche');
        clearSelectField('modelo_coche');
        clearSelectField('ccaa_comprador');
      } else if (vehVal === 'veh_moto') {
        clearTextField('marca_moto');
        clearTextField('modelo_moto');
        clearSelectField('cilindrada_moto');
        clearSelectField('ccaa_comprador');
      }
      clearTextField('modelo_vehiculo_no_listado');
      clearTextField('cilindrada_vehiculo_no_listado');
      clearTextField('potencia_fiscal_vehiculo_no_listado');
      clearTextField('fecha_primera_matriculacion');
      clearTextField('hidden_antiguedad');
      clearVehiculoHidden();
      return;
    }

    // Limpiar los campos que venían del catálogo de coches
    ['hidden_impvehic', 'hidden_marca_coche', 'hidden_modelo_coche',
      'hidden_combustible', 'hidden_cilindros', 'hidden_potencia_kw',
      'hidden_potencia_cv'].forEach(clearTextField);

    // Copiar los campos manuales a los hidden fields correspondientes
    var cilEl = document.querySelector('[name="cilindrada_vehiculo_no_listado"]');
    var pvEl  = document.querySelector('[name="potencia_fiscal_vehiculo_no_listado"]');
    var cilVal = cilEl ? cilEl.value.trim() : '';
    var pvVal  = pvEl  ? pvEl.value.trim()  : '';

    document.querySelectorAll('[name="hidden_cilindrada"]').forEach(function (el) {
      el.value = cilVal;
      dispatchEvents(el);
    });
    document.querySelectorAll('[name="hidden_potencia_fiscal"]').forEach(function (el) {
      el.value = pvVal;
      dispatchEvents(el);
    });

    window.dispatchEvent(new CustomEvent('itp:vehiculo-updated'));
  }

  function waitForElement(selector, callback) {
    var el = document.querySelector(selector);
    if (el) { callback(el); return; }
    var obs = new MutationObserver(function () {
      var found = document.querySelector(selector);
      if (found) { obs.disconnect(); callback(found); }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // Listener principal del checkbox
  waitForElement('[name="checkbox_veh_no_listado"]', function (cb) {
    cb.addEventListener('change', syncCamposNoListado);
  });

  // Listeners en los campos manuales: re-sincronizan si el checkbox ya está marcado
  ['cilindrada_vehiculo_no_listado', 'potencia_fiscal_vehiculo_no_listado'].forEach(function (name) {
    waitForElement('[name="' + name + '"]', function (el) {
      el.addEventListener('input', function () {
        var cb = document.querySelector('[name="checkbox_veh_no_listado"]');
        if (cb && cb.checked) syncCamposNoListado();
      });
    });
  });

});



// WEBPACK FOOTER //
// ./scripts/formularios-itp/catalogos-vehiculos.js